<template>
  <div>
    <el-row>
      <el-col class="pull-left" style="width: 150px; margin-right: 20px">
        <el-select v-model="params.type" @change="handleTypeChange">
          <el-option :value="undefined" label="全部"></el-option>
          <el-option :value="1" label="普通充值"></el-option>
          <el-option :value="2" label="下级返利"></el-option>
          <el-option :value="3" label="每日签到"></el-option>
          <el-option :value="4" label="饰品出售"></el-option>
          <el-option :value="5" label="抽奖消耗"></el-option>
          <el-option :value="7" label="商城消费"></el-option>
          <el-option :value="15" label="每日任务"></el-option>
          <el-option :value="101" label="渠道返利"></el-option>
          <el-option :value="99" label="特殊cdk"></el-option>
          <el-option :value="25" label="微信CDK"></el-option>
          <el-option :value="26" label="金币roll"></el-option>
          <el-option :value="102" label="coins币"></el-option>
          <el-option :value="34" label="战团"></el-option>
          <el-option :value="100" label="其他"></el-option>
        </el-select>
      </el-col>
      <el-col
        class="pull-left"
        style="width: 150px; margin-right: 20px"
        v-if="params.type === 101"
      >
        <el-select v-model="params.genre">
          <el-option :value="1" label="下级返利"></el-option>
          <el-option :value="2" label="提取金额"></el-option>
        </el-select>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-col class="pull-left" style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束时间"
        >
        </el-date-picker>
      </el-col>
      <el-button
        style="margin-right: 20px"
        size="small"
        class="pull-left"
        type="primary"
        @click="handleTypeChange"
      >
        搜索
      </el-button>
      <el-col style="width: 180px; margin-right: 20px; line-height: 32px">
        <span>变动总金额：{{ changeAmount }}</span>
      </el-col>
      <el-col style="width: 180px; margin-right: 20px; line-height: 32px">
        <span>返利总额：{{ rebateAmount }}</span>
      </el-col>
      <el-col style="width: 100px; line-height: 32px">
        <el-button
          size="small"
          type="primary"
          @click="handleExport"
          :loading="buttonLoading"
        >
          导出
        </el-button>
      </el-col>
    </el-row>
    <el-table v-if="params.type != 101" v-loading="loading" :data="dataList">
      <el-table-column prop="before_money" label="变更前金额"></el-table-column>
      <el-table-column prop="after_money" label="变更后金额"></el-table-column>
      <el-table-column prop="change_money" label="变更金额">
        <template slot-scope="{ row }">
          <span v-if="row.change_money >= 0" style="color: #67c23a"
            >+{{ row.change_money }}</span
          >
          <span v-else style="color: #f56c6c">{{ row.change_money }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="变更时间"></el-table-column>
      <el-table-column prop="type" label="变更类型" v-if="params.type != 102">
        <template slot-scope="{ row }">
          <span v-if="row.type === 1">充值/开箱/折价</span>
          <span v-if="row.type === 2">下级返利</span>
          <span v-if="row.type === 3">每日福利</span>
          
          <span v-if="row.type === 4">饰品出售</span>
          <span v-if="row.type === 5">抽奖消耗</span>
          <span v-if="row.type === 7">商城消费</span>
          <span v-if="row.type === 15">每日任务</span>
          <span v-if="row.type === 101">渠道返利</span>
          <span v-if="row.type === 99">特殊cdk</span>
          <span v-if="row.type === 25">微信CDK</span>
          <span v-if="row.type === 26">金币roll</span>
          <span v-if="row.type === 102">coins币</span>
          <span v-if="row.type === 34">战团</span>
          <span v-if="row.type === 100">其他</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="变更类型" v-else>
        <template slot-scope="{ row }">
          <span v-if="row.type === 1">商城</span>
          <span v-if="row.type === 2">开箱</span>
          <span v-if="row.type === 3">对战</span>
          <span v-if="row.type === 4">失效</span>
          <span v-if="row.type === 5">赠送</span>
          <span v-if="row.type === 6">领取</span>
          <span v-if="row.type === 7">清除</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="300px"
      ></el-table-column>
    </el-table>

    <!-- 渠道返利 -->
    <el-table v-else v-loading="loading" :data="dataList">
      <el-table-column prop="before_money" label="推广前金额"></el-table-column>
      <el-table-column prop="after_money" label="推广后金额"></el-table-column>
      <el-table-column prop="change_money" label="变更金额">
        <template slot-scope="{ row }">
          <span v-if="row.change_money >= 0" style="color: #67c23a"
            >+{{ row.change_money }}</span
          >
          <span v-else style="color: #f56c6c">{{ row.change_money }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="rebate_amount"
        label="当前可提取金额"
      ></el-table-column>
      <el-table-column prop="updated_at" label="变更时间"></el-table-column>
      <el-table-column prop="type" label="变更类型">
        <template slot-scope="{ row }">
          <span v-if="row.genre === 1">下级返利</span>
          <span v-if="row.genre === 2">提取金额</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="300px"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import http, { getData, server } from '../../http'
import saveFile from '../../utils/saveFile'
export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      changeAmount: 0,//变动总额
      rebateAmount: 0,//返利总额
      dataList: undefined,
      dataMeta: {},
      loading: false,
      buttonLoading: false,//加载按钮动画
      page: 1,
      params: {
        type: undefined,
        genre: 1,//下级返利是1 提取金额是2
        start_time: undefined,
        end_time: undefined
      }
    }
  },

  methods: {
    getChangeAmount() {
      getData(`balance_amount/${this.id}`, { page: this.page, type: this.params.type, start_time: this.params.start_time, end_time: this.params.end_time })
        .then(res => {
          this.changeAmount = res.change_amount
          this.rebateAmount = res.rebate
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTableData() {
      this.loading = true
      let params = { page: this.page, type: this.params.type, start_time: this.params.start_time, end_time: this.params.end_time, genre: this.params.genre }
      getData(`balance/${this.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.page = page
      this.getTableData()
    },
    handleTypeChange() {
      this.page = 1
      this.getTableData()
    },
    handleExport() {
      if (!this.params.start_time || !this.params.end_time) {
        this.$message.warning('开始时间与结束时间必须填写')
        return
      }
      if (this.buttonLoading) {
        this.$message.success('正在导出请勿重复点击')
        return
      }
      this.buttonLoading = true
      http
        .post(
          server + `balance_export/${this.id}`,
          { ...this.params, page: undefined },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '余额日志.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  },
  created() {
    this.getTableData()
    this.getChangeAmount()
  }
}
</script>

<style>
</style>
